import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        disabled: '=',
        form: '=',
        scale: '=',
        matrix: '=',
        scaleSteps: '='
    },
    template: `
        <div ng-if="vm.form.model.type === vm.QUESTIONS_TYPE_ENUM.KEYS.MATRIX">
            <h3>{{ 'questionAnswer.Rows' | translate }}</h3>
            <ul dnd-list="vm.matrix.list" class="items06">
                <!-- The dnd-draggable directive makes an element draggable and will
                     transfer the object that was assigned to it. If an element was
                     dragged away, you have to remove it from the original list
                     yourself using the dnd-moved attribute -->
                <li ng-repeat="item in vm.matrix.list"
                    dnd-draggable="item"
                    dnd-moved="vm.matrix.list.splice($index, 1)"
                    dnd-effect-allowed="move"
                    dnd-selected="vm.matrix.selected = item"
                    ng-class="{'active': vm.matrix.selected === item, 'error': item.status === 'error', 'is-dragging': vm.down}"
                    dnd-dragend="vm.down=false"
                    dnd-dragstart="vm.down=true"
                >
                    <dnd-nodrag>
                        <div dnd-handle class="handle"></div>
                        <p ng-if="vm.matrix.list[$index].label" class="show-on-drag">{{ vm.matrix.list[$index].label }}</p>
                        <p ng-if="!vm.matrix.list[$index].label" class="show-on-drag">{{ 'question.Answer' | translate }}</p>
                        <div class="form hide-on-drag">
                            <form-row error="vm.form.errors.childQuestions[$index].questionI18ns[vm.defaultLanguage].name">
                                <label class="label" style="flex: 0 1 150px;min-width:0">{{ 'questionAnswer.Text' | translate }}</label>
                                <div class="items">
                                    <input ng-disabled="vm.disabled" ng-model="vm.matrix.list[$index].label" type="text" class="form-control">
                                    <form-row-error></form-row-error>
                                </div>
                                <a ng-if="!vm.disabled" style="margin-left:2.3em;margin-top:1.3em;" ng-click="vm.removeMatrixItem($index)" class="btn delete"></a>
                            </form-row>
                        </div>
                    </dnd-nodrag>
                </li>
            </ul>
            <ul class="actions01">
                <li><a ng-if="!vm.disabled" class="btn add" ng-click="vm.QuestionService.addMatrixValue(vm.matrix)">{{ 'questionAnswer.Add row' | translate }}</a></li>
            </ul>
        </div>
        <div class="row">
            <label class="label">{{ 'questionAnswer.Steps' | translate }}</label>
            <div class="items">
                <input ng-disabled="vm.disabled" ng-change="vm.setScaleRange()" type="number" ng-model="vm.scaleSteps" class="form-control" min="1">
            </div>
        </div>
        <div class="row">
            <label class="label">{{ 'questionAnswer.Labels' | translate }}</label>
            <div class="items">
                <table dnd-list="vm.scale.list" class="dnd">
                    <colgroup>
                        <col width="1%"/>
                        <col width="99%"/>
                    </colgroup>
                    <tbody>
                        <tr ng-repeat="item in vm.scale.list"
                        dnd-draggable="item"
                        dnd-moved="vm.moveScale($index)"
                        dnd-effect-allowed="move"
                        dnd-selected="vm.scale.selected = item"
                        ng-class="{'active': vm.scale.selected === item}"
                    >
                            <td>
                                <span class="text">{{item.value}}</span>
                            </td>
                            <td>
                                <input ng-disabled="vm.disabled" ng-model="vm.scale.list[$index].label" type="text" class="form-control">
                                <p ng-if="vm.form.errors.questionAnswers[$index].translations" class="desc error has-error">
                                    {{ vm.form.errors.questionAnswers[$index].translations[vm.defaultLanguage].text }}
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="row">
            <span class="label">{{ 'questionAnswer.Display settings' | translate }}</span>
            <div class="items">
                <ul class="checkboxes c-both">
                    <li><label><input ng-disabled="vm.disabled" ng-model="vm.form.model.allowNAOption" type="checkbox"> {{ 'questionAnswer.Allow N/A option' | translate }}</label></li>
                </ul>
            </div>
        </div>
    </div>
    `
})

export default class {
    constructor (lodash, TokenService, QuestionService, QUESTIONS_TYPE_ENUM) {
        this.lodash = lodash;
        this.QuestionService = QuestionService;
        this.QUESTIONS_TYPE_ENUM = QUESTIONS_TYPE_ENUM;
        this.defaultLanguage = TokenService.getCompanyLanguage();
        this.down = false;
    }

    setScaleRange () {
        if (this.scaleSteps) {
            const scaleDndModelCopy = angular.copy(this.scale.list);

            // add if steps are more than rows
            if (this.scaleSteps - scaleDndModelCopy.length > 0) {
                // set scaleSteps to be max 10 if bigger than 10 number is inserted by hand
                if (this.scaleSteps > 10) {
                    this.scaleSteps = 10;
                }

                for (let i = 0; i < this.scaleSteps - scaleDndModelCopy.length; i++) {
                    this.QuestionService.addScaleValue(this.scale, this.scale.list.length + 1, this.scale.list.length + 1);
                }
            }
            // remove if steps are less than rows
            else {
                this.lodash.forEach(scaleDndModelCopy, (item, key) => {
                    if (key >= this.scaleSteps) {
                        this.scale.list.pop();
                    }
                });
            }
        }
    }

    moveScale (index) {
        this.scale.list.splice(index, 1);

        // reorganize numbers
        this.lodash.forEach(this.scale.list, (item, key) => {
            this.scale.list[key].value = key + 1;
        });
    }

    removeMatrixItem (key) {
        if (this.matrix.list.length > 1) {
            this.matrix.list.splice(key, 1);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/questions/actions/answers/scaleMatrixType/index.js